import flowApi from '../api/flowApi'
async function substepVerify(currentStepObj) {
    let currentSubstep = currentStepObj.steps[currentStepObj.current]
    if (currentSubstep && currentSubstep.steps) return substepVerify(currentSubstep)
    return currentSubstep

}
async function nextStep(processId, stepScore){
    const user = JSON.parse(localStorage.getItem('player'))
    const token = user.token
    const workspaceId = localStorage.getItem('workspaceId')
    const uid = localStorage.getItem('uid')
    const flowData = JSON.parse(localStorage.getItem('flowData'))
    // console.log('flowData!!: ', flowData)
    const currentSubstep = await substepVerify(flowData)
    // console.log('Current SUBstep Verify: ', currentSubstep)
    if(currentSubstep.status == 'pending'){
        try {
            let stepCallback = await flowApi.post(`/owned-processes/${processId}/steps/current/callback`,{"score": stepScore})
            // console.log('Callback: ', stepCallback.data)
        } catch (error) {
            const message = 'Erro no callback'
            //TODO: make a error message showing up instead console.log error
            // console.error(message, error)
            // alert(message)
        }
    }
    try {
        const nextStepReq = await flowApi.post(`/owned-processes/${processId}/steps/next`, {})
        // console.log('Next step: ', nextStepReq.data)
        // console.log('redirecionando...')
        window.location.replace(`${nextStepReq.data.url}?uid=${uid}&workspaceId=${workspaceId}&token=${token}`);
    } catch (error) {
        const message = 'Erro ao dar o próximo passo'
        //TODO: make a error message showing up instead console.log error
        // console.error(message, error)
        alert(message)
    }
    


}

export default nextStep 